import src from "IMAGE";
export default { src, width: 354, height: 265, blurWidth: 0, blurHeight: 0};
